import { useState, useEffect } from 'react';
import services from 'services';

import { ImportToolDetails } from 'components';

interface ImporttoolState {
  templateLink: string | null;
  loading: boolean;
  error: boolean;
}

const Importtool = () => {
  const [state, setState] = useState<ImporttoolState>({
    templateLink: null,
    loading: false,
    error: false,
  });

  useEffect(() => {
    let mounted = true;

    const fetchImportSettings = async () => {
      try {
        setState((prevState) => ({
          ...prevState,
          loading: true,
          error: false,
        }));

        const templateLink: string = (
          await services.get('/api/import/settings')
        ).data.Data.TemplateLink;

        if (mounted) {
          console.log('mounted');
          setState((prevState) => ({
            ...prevState,
            loading: false,
            templateLink,
          }));
        }
      } catch (err) {
        console.error(err);
        if (mounted) {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            error: true,
          }));
        }
      }
    };

    fetchImportSettings();

    return () => {
      mounted = false;
    };
  }, []);

  return <ImportToolDetails {...state} />;
};

export default Importtool;
